export default {
  activation: 'ACTIVATION',
  cancellation: 'CANCELLATION',
};
